import React from 'react';
import styles from './shoppingListTrigger.module.scss';
import useTranslation from 'next-translate/useTranslation';

export default function ShoppingListTrigger(): JSX.Element {
  const { t } = useTranslation('application');
  return (
    <div className={styles.slNavArea}>
      <button className={styles.slButton}>
        <div className={styles.pillArea}>
          <span className={styles.listCount}>
            <div className={styles.slIcon}>
              <img
                className="icon"
                height="20px"
                src="https://f.wishabi.net/creative/Distribution/images/icons/list-outline-default5.svg"
                alt=""
              />
            </div>
          </span>
          <span className={styles.label}>{t('shopping_list')}</span>
        </div>
      </button>
    </div>
  );
}
